import { FC } from "react";
import { tv } from "tailwind-variants";

import { cn } from "@/util";

const gradientShadow = tv({
  base: "absolute rounded-full to-transparent blur-2xl",
  variants: {
    pos: {
      br: "-bottom-1/2 -right-12 bg-gradient-to-tl",
      bl: "-bottom-40 -left-10 bg-gradient-to-tr",
      tr: "-top-32 -right-28 bg-gradient-to-bl",
      tl: "-top-32 -left-28 bg-gradient-to-br",
    },
    color: {
      white: "from-white/40 contrast-200 blur-xl z-10 w-32 md:w-32 h-36",
      purple: "from-themePurple/80 contrast-200 w-32 md:w-52 h-40 md:h-44",
      red: "from-themeRed/70 contrast-150 w-32 md:w-52 h-40 md:h-52",
      blue: "from-themeBlue/50 contrast-125 w-40 md:w-52 h-52 md:h-40",
    },
  },
  compoundVariants: [
    {
      pos: "bl",
      color: "white",
      class: "bottom-10 -left-24 bg-gradient-to-br w-20 md:w-40 h-36 md:h-40",
    },
    {
      pos: "bl",
      color: "purple",
      class: "-bottom-32 -left-40",
    },
    {
      pos: "bl",
      color: "red",
      class: "bottom-10 -left-20",
    },
    {
      pos: "br",
      color: "blue",
      class: "from-blue-500 contrast-200",
    },
  ],
});

interface GradientShadowProps {
  type: "bl" | "br" | "tl" | "tr";
  color?: string;
}

export const GradientShadow: FC<GradientShadowProps> = ({ type, color }) => {
  return (
    <>
      <div
        className={cn(
          type === "tr" &&
            gradientShadow({ color: color ? "blue" : "purple", pos: "tr" }),
          type === "tl" && gradientShadow({ color: "blue", pos: "tl" }),
          type === "br" && gradientShadow({ color: "blue", pos: "br" })
        )}
      />
      <div
        className={cn(
          type === "tr" &&
            gradientShadow({ color: color ? "blue" : "purple", pos: "tr" }),
          type === "tl" && gradientShadow({ color: "blue", pos: "tl" }),
          type === "br" && gradientShadow({ color: "blue", pos: "br" }),
          type === "bl" && gradientShadow({ color: "red", pos: "bl" })
        )}
      />
      <div
        className={cn(
          type === "tr" && gradientShadow({ color: "white", pos: "tr" }),
          type === "tl" && gradientShadow({ color: "white", pos: "tl" }),
          type === "br" && gradientShadow({ color: "white", pos: "br" }),
          type === "bl" && gradientShadow({ color: "white", pos: "bl" })
        )}
      />
      <div
        className={cn(
          type === "tr" && gradientShadow({ color: "white", pos: "tr" }),
          type === "tl" && gradientShadow({ color: "white", pos: "tl" }),
          type === "br" && gradientShadow({ color: "white", pos: "br" })
        )}
      />
    </>
  );
};
